$(function () {

  var invoiceFields = ['billStreet', 'billHouseNumber', 'billCity', 'billZip', 'billCountryId'];
  var storageKey = 'selected-shipping-id-' + window.location.hostname.replace(/^www\./, '');
  var $body = $('body');
  var $billing = $('.co-billing-address');
  var $contact = $('.co-contact-information');

  function getStoredShippingId() {
    var val = localStorage.getItem(storageKey);
    return val ? parseInt(val) : null;
  }

  function disableInvoiceValidation() {
    $.each(invoiceFields, function (i, fieldId) {
      var $input = $('#' + fieldId);
      var $label = $('[for="' + fieldId + '"]');
        $input.closest('.form-group').removeClass('js-validated-element-wrapper')
      $input.removeAttr('required')
            .removeClass('required js-validate js-validate-required');

      var originalText = $label.text().replace('*', '').trim();
      $label.text(originalText);
    });
  }

  function highlightRequiredFields() {
    $.each(invoiceFields, function (i, fieldId) {
      var $input = $('#' + fieldId);
      var $label = $('[for="' + fieldId + '"]');
      $label.html('<span class="required-asterisk">' + $label.text() + '</span>');
      $input.addClass('js-validate js-validate-required');
    });
  }

  function insertInvoiceCheckbox() {
    var html = `
      <div class="form-group" style="display:block!important;">
        <input type="checkbox" id="toggle-invoice">
        <label for="toggle-invoice" class="whole-width">Chci zadat fakturační adresu</label>
      </div>
    `;
    $contact.append(html);
  }

  function bindCheckboxToggle() {
    $(document).on('change', '#toggle-invoice', function () {
      if ($(this).is(':checked')) {
        $billing.addClass('visible');
        highlightRequiredFields();
        $.each(invoiceFields, function (i, fieldId) {
          $('#' + fieldId).attr('required', true);
        });
      } else {
        $billing.removeClass('visible');
        disableInvoiceValidation();
      }
    });
  }

  // Uložení zvolené dopravy v kroku 1
  if ($body.hasClass('id--16')) {
    $(document).on('click', '#orderFormButton', function () {
      var selectedId = $('[name="shippingId"]:checked').val();
      if (selectedId) {
        localStorage.setItem(storageKey, selectedId);
      }
    });
  }

  // Skrytí fakturační adresy v kroku 2 podle dopravy
  if ($body.hasClass('id--17')) {
    highlightRequiredFields(); // Výchozí stav

    var shippingId = getStoredShippingId();
    if ($.inArray(shippingId, allowedShippingIds) > -1) {
       $('.co-billing-address label[for="another-shipping"]').hide();
      disableInvoiceValidation();
      $billing.addClass('js-hidden');
      insertInvoiceCheckbox();
      bindCheckboxToggle();
     
    }
    else{
        
    }
  }
});